import { Progress } from "antd";

import { BaseProgressBarProps } from "./types";

import "./styles.css";

const DEFAULT_BAR_HEIGHT = 8;

const BaseProgressBar = ({
  value,
  total,
  label,
  helpText,
  description,
  descriptionAlign = "center",
  strokeWidth = DEFAULT_BAR_HEIGHT,
  ...props
}: BaseProgressBarProps) => {
  const percent = Math.floor((value / total) * 100);
  return (
    <div className="flex flex-col full-width">
      <div className="flex flex-wrap justify-between gap-200 items-center full-width">
        {label && (
          <h6 className="base-progress-bar-label body-m-regular">{label}</h6>
        )}

        {helpText && (
          <p className="base-progress-bar-help-text body-m-regular">
            {helpText}
          </p>
        )}
      </div>

      <Progress
        percent={percent}
        showInfo={false}
        className="full-width"
        strokeColor={"var(--primary-1000)"}
        trailColor={"var(--neutral-200)"}
        size={{ height: strokeWidth }}
        {...props}
      />

      {description && (
        <p
          className={`base-progress-bar-description base-progress-bar-description-${descriptionAlign} body-s-regular`}
        >
          {description}
        </p>
      )}
    </div>
  );
};

export default BaseProgressBar;
